import React from "react";
import { Box, List, Skeleton, Typography } from "@mui/material";

import { COLORS } from "constants/colors";
import { useVendorAttributesQuery } from "./hooks/useVendorAttributes";

function formatValue(type, value) {
  if (value == null) { return "—"; }
  if (type === "boolean") { return value === "true" ? "" : "No"; }
  if (type === "array") {
    try {
      return JSON.parse(value).join(", ");
    } catch {
      return value;
    }
  }
  return value;
}

function VendorAttributeCard({ vendorsVendorAttr }) {
  const { name, type } = vendorsVendorAttr.vendorAttribute;
  return (
    <Box sx={{
      mb: 1,
      p: 2,
      borderRadius: 2,
      boxShadow: `inset 0px 0px 0px 1px ${COLORS.OFFSET}`
    }}>
      <Typography variant="h3">{name}</Typography>
      <Typography variant="body2">{formatValue(type, vendorsVendorAttr.value)}</Typography>
    </Box>
  );
}

const VendorAttributes = ({ vendorId }) => {
  const { isLoading, data } = useVendorAttributesQuery(vendorId);

  if (isLoading) {
    return <Skeleton variant="rectangular" width="300px" height={100} />;
  }

  if (!data || data.length === 0) {
    return <Typography variant="body2">None</Typography>;
  }

  return (
    <List>
      {data.map((attr) => (
        <VendorAttributeCard key={attr.id} vendorsVendorAttr={attr} />
      ))}
    </List>
  );
};

export default VendorAttributes;
